/* K-WORLDWIDE — ARTICLE SHARE
   Native Web Share API on mobile + manual buttons fallback.
   Includes copy-to-clipboard with toast feedback.
*/
(() => {
  'use strict';

  const shareContainer = document.querySelector('.kw-article-meta__share');
  if (!shareContainer) return;

  const articleUrl = window.location.href;
  const articleTitle = document.title;

  // Copy link button
  const copyBtn = shareContainer.querySelector('[data-share="copy"]');
  if (copyBtn) {
    copyBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(articleUrl);
        showToast(copyBtn.dataset.toastSuccess || 'Link copiato');
      } catch (err) {
        showToast(copyBtn.dataset.toastError || 'Impossibile copiare', true);
      }
    });
  }

  // Native share button (mobile-first)
  const nativeBtn = shareContainer.querySelector('[data-share="native"]');
  if (nativeBtn) {
    if (navigator.share) {
      nativeBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        try {
          await navigator.share({ title: articleTitle, url: articleUrl });
        } catch (err) {
          // User cancelled or share failed — silent
        }
      });
    } else {
      nativeBtn.style.display = 'none';
    }
  }

  function showToast(message, isError = false) {
    const existing = document.querySelector('.kw-share-toast');
    if (existing) existing.remove();
    
    const toast = document.createElement('div');
    toast.className = 'kw-share-toast' + (isError ? ' kw-share-toast--error' : '');
    toast.textContent = message;
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
    
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    }, 2400);
  }

})();